export default {
  groupAllocationList_00001: "",
}